// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound-root-wz0At {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 100px;
  padding-bottom: 30px;
  min-height: calc(100vh - 295px);
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.NotFound-container-elkr4 {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-content-width);
}

@media (max-width: 1199px) and (min-width: 1024px) {
  .NotFound-root-wz0At {
    min-height: calc(100vh - 311px);
  }
}

@media (max-width: 1023px) and (min-width: 768px) {
  .NotFound-root-wz0At {
    min-height: calc(100vh - 321px);
  }
}

@media (max-width: 767px) {
  .NotFound-root-wz0At {
    min-height: calc(100vh - 311px);
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/not-found/NotFound.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA8C;EAC9C,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE;IACE,+BAA8C;EAChD;AACF;;AAEA;EACE;IACE,+BAA+C;EACjD;AACF;;AAEA;EACE;IACE,+BAA8C;EAChD;AACF","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 100px;\n  padding-bottom: 30px;\n  min-height: calc(100vh - (80px + (430px / 2)));\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-content-width);\n}\n\n@media (max-width: 1199px) and (min-width: 1024px) {\n  .root {\n    min-height: calc(100vh - (96px + (430px / 2)));\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n  .root {\n    min-height: calc(100vh - (106px + (430px / 2)));\n  }\n}\n\n@media (max-width: 767px) {\n  .root {\n    min-height: calc(100vh - (96px + (430px / 2)));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NotFound-root-wz0At`,
	"container": `NotFound-container-elkr4`
};
module.exports = ___CSS_LOADER_EXPORT___;
